import React from "react";
import BotSubmissionForm from "./forms/BotSubmissionForm";
import {Route, Routes, Navigate } from "react-router-dom";
import BotMenu from "./Menus/BotMenu";
import CallbackPage from "./CallbackPage";
import { useUser } from "./UserContext";
import Leaderboard from "./Leaderboard";
import UserProfile from "./Menus/UserProfile";
import Home from "./Home";



const RoutesDef = () => {

    const PrivateRoute = ({ children }) => {
        const { user } = useUser();

      
        return user ? children : <Navigate to="/" />;
      };

    return (
        <div>
            <div className="App text-white min-h-screen mt-20">
                <main className="mx-auto">
                    <Routes>

                    <Route index element={<Home />} />

                    <Route path="submit-seed" element={
                        <PrivateRoute>
                        <BotSubmissionForm/>
                        </PrivateRoute>
                    } />

                    <Route path="leaderboard" element={<Leaderboard />} />
                    <Route path="callback" element={<CallbackPage />} />
                    {/* Add a 404 Page */}
                    <Route path="*" element={<div>404 - Page Not Found</div>} />

                    {/*Dynamic routes*/}
                    <Route path="profiles/:twitchDisplayName/:botTag" element={<BotMenu />} />
                    <Route path="profiles/:twitchDisplayName" element={<UserProfile />} />

                    </Routes>
                </main>
            </div>
        </div>
    );
}

export default RoutesDef;

